import { axiosInstance } from "../core/http";

export const eventsApi = {
  getSubEvents: () => axiosInstance.get(`/api/state/event/sub-types/`),
};
